/**
 * Shared Intl format configs used by both vue-intl and react-intl.
 * These map named presets (e.g., "currency", "short") to standard
 * Intl.NumberFormat / Intl.DateTimeFormat options.
 */

export type NumberFormatPreset =
  | "currency"
  | "currencyDetailed"
  | "currencyDtfCents"
  | "currencyNoCents";

export type DateFormatPreset = "short" | "medium" | "full" | "month" | "day" | "weekday";

export const numberFormats: Record<string, Record<NumberFormatPreset, Intl.NumberFormatOptions>> = {
  "en-US": {
    currency: {
      style: "currency",
      currency: "USD"
    },
    currencyDetailed: {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    },
    currencyDtfCents: {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 3,
      maximumFractionDigits: 4
    },
    currencyNoCents: {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  },
  "en-CA": {
    currency: {
      style: "currency",
      currency: "CAD",
      currencyDisplay: "code"
    },
    currencyDetailed: {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 4,
      currencyDisplay: "code"
    },
    currencyDtfCents: {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 3,
      maximumFractionDigits: 4,
      currencyDisplay: "code"
    },
    currencyNoCents: {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: "code"
    }
  }
};

export const dateFormats: Record<DateFormatPreset, Intl.DateTimeFormatOptions> = {
  short: { month: "numeric", day: "numeric" },
  medium: { month: "short", day: "numeric", weekday: "long" },
  full: { month: "short", day: "numeric", year: "numeric" },
  month: { month: "short" },
  day: { day: "numeric" },
  weekday: { weekday: "long" }
};
